import { Component, OnInit, Input, ChangeDetectorRef, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { format, parse } from 'date-fns';
import { Subscription } from 'rxjs';
import { TaskListEnum } from 'src/app/enums/taskList';
import { ApiService } from 'src/app/services/api.service';
@Component({
  selector: 'app-tasklist-airworthiness',
  templateUrl: './tasklist-airworthiness.component.html',
  styleUrls: ['./tasklist-airworthiness.component.scss'],
})
export class TaskListAirWorthinessComponent implements OnInit {
  @Input() data: any;
  @Input() assetTypeId: any;
  @Input() assetId: any;
  @ViewChildren('tooltipRef') tooltips: QueryList<any>;
  formTitle: string;
  taskListAirWorthinessForm: FormGroup;
  maxDate: Date = new Date();
  isSaving: boolean = false;
  taskIdList: any = [];
  public taskListAirWorthinessSub: Subscription;
  public awdbSub: Subscription;
  taskListEnums = TaskListEnum;
  status: any = [
    'OPEN',
    'C/W - REPETITIVE',
    'C/W - TERMINATED',
    'SUPERSEDED',
    'ACCOMPLISHED IN PRODUCTION',
    'NOT APPLICABLE',
  ];
  filteredItems: any[];
  maintenanceTypeList: any = [];
  selectedMaintenanceTypeList: any;
  // maintenanceTypeList:any=[{name:' Air Worthiness Directive',value:1},{name:'MPD',value:5}]
  editableForm: boolean = false;
  summaryApiGetCallResponse: boolean = false;
  formDisableEnableUsingRepairDamageValue: boolean = false;
  repairDamageFieldsShowHide: boolean = false; // this will use to show form fields only for repair damage
  occureArray: any[];
  airCraftData: any;
  taskIdLoadingDataLength: boolean = false;
  repairClassification = ['minor', 'major'];
  constructor(
    private route: ActivatedRoute,
    private modalController: ModalController,
    public apiService: ApiService,
  ) {
    this.getDataMaintenanceId();
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.airCraftData = params; // Save query parameters

    });
    this.occureArray = [
      { value: 'First', label: 'First' },
      { value: 'Last', label: 'Last' },
    ];

    this.taskListAirWorthinessForm = new FormGroup({
      // assetTypeId: new FormControl(''),
      assetId: new FormControl(''),
      maintenanceTypeId: new FormControl(''),
      statusListId: new FormControl('', [Validators.required]),
      thresholdTat: new FormControl(''),
      thresholdTac: new FormControl(''),
      repeatIntervalDays: new FormControl(''),
      repeatIntervalFh: new FormControl(''),
      repeatIntervalFc: new FormControl(''),
      thresholdDate: new FormControl(''),
      thresholdDays: new FormControl(''),
      occurrenceAlertRepeatInterval: new FormControl(''),
      occurrenceAlertThreshold: new FormControl(''),
      status: new FormControl('', [Validators.required]),
    });
    // }

    this.formTitle = 'Add ' + this.taskListEnums.AIRWORTHINESSDIRECTIVESTATUS;

    if (this.data !== null) {
      this.summaryApiGetCallResponse = true;
      this.setForm();
      // this.getData()
    }
  }

  public getDataMaintenanceId(): void {
    try {
      (this.awdbSub = this.apiService.getMaintenanceId().subscribe(
        (res: any[]) => {
          if (res?.length !== undefined) {
            res.map((e) => {
              if (!this.data) {
                if (this.taskListEnums.AIRWORTHINESSDIRECTIVESTATUS == e.name) {
                  this.maintenanceTypeList.push({ name: e.name, value: e.id });
                  this.taskListAirWorthinessForm.controls.maintenanceTypeId.setValue(e.id);
                  this.maintenanceTaskChangebyMaintenanceType({ name: e.name, value: e.id });
                }
              } else {
                this.maintenanceTypeList.push({ name: e.name, value: e.id });
              }
            });
            // if(this.data){
            //   if (this.data?.maintenanceTypeName !== this.taskListEnums.REPAIRDAMAGE) {
            //     this.repairDamageFieldsShowHide = true; //hide form fields if the value changed
            //     this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(true);
            //   } else {
            //     this.repairDamageFieldsShowHide = false;
            //     this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
            //   }
            // }
            if (this.data) {
              this.taskIdList = [];
              this.selectedMaintenanceTypeList = this.maintenanceTypeList.find(
                (e) => e.value == this.data?.maintenanceTypeId
              );
                this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
                this.repairDamageFieldsShowHide = false;
                this.getData({name:'id',value:this.data?.statusListId});
            }
            // this.maintenanceId = res.find(e=> e.name === 'REPAIR DAMAGE');
          }
        },
        (err: any) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      )),
        (err: any) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }
  toggleEditableForm(): void {
    this.editableForm = true;
  }
  isDisabled(): boolean {
    return this.data ? this.editableForm : false;
  }

  public getData(filter:any): void {
    try {
      this.taskIdList = [];
      this.taskIdLoadingDataLength = false;
      const params = {
        page: 1,
        limit: 1000,
        filter
      };
      this.awdbSub = this.apiService.getAirDirectives(params).subscribe((res: any) => {
        if (res?.data?.length !== undefined) {
          this.taskIdList = res.data;
          this.filteredItems = res.data;
          if(this.data?.statusListId){
            this.taskListAirWorthinessForm.patchValue({ statusListId: this.data?.statusListId }); // or whatever initial value
          }
        }
      });
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }

  public setForm(): void {
    if (this.data?.id > 0) {
      this.formTitle = this.data
        ? 'Edit ' + ' ' + this.taskListEnums.AIRWORTHINESSDIRECTIVESTATUS
        : 'Add ' + ' ' + this.taskListEnums.AIRWORTHINESSDIRECTIVESTATUS

      this.taskListAirWorthinessForm = new FormGroup({
        assetId: new FormControl(this.data?.assetId),
        maintenanceTypeId: new FormControl(this.data?.maintenanceTypeId, [Validators.required]),
        statusListId: new FormControl('', [Validators.required]),
        thresholdTat: new FormControl(this.data?.thresholdTat),
        thresholdTac: new FormControl(this.data?.thresholdTac),
        repeatIntervalDays: new FormControl(this.data?.repeatIntervalDays),
        repeatIntervalFh: new FormControl(this.data?.repeatIntervalFh),
        repeatIntervalFc: new FormControl(this.data?.repeatIntervalFc),
        thresholdDate: new FormControl(this.data?.thresholdDate && this.data?.thresholdDate?.toString() !== '0000-00-00' ? parse(this.data?.thresholdDate, 'yyyy-MM-dd', new Date()) : null),
        thresholdDays: new FormControl(this.data?.thresholdDays),
        occurrenceAlertRepeatInterval: new FormControl(this.data?.occurrenceAlertRepeatInterval),
        occurrenceAlertThreshold: new FormControl(this.data?.occurrenceAlertThreshold),
        status: new FormControl(this.data?.status, [Validators.required]),
        id: new FormControl(this.data?.id),
      });
    }
    this.summaryApiGetCallResponse = false;
  }

  dismissModal() {
    this.selectedMaintenanceTypeList = null;
    this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
    this.modalController.dismiss({
      dismissed: false,
    });
  }

  public submit(): void {
    if (this.taskListAirWorthinessForm.invalid) {
      this.taskListAirWorthinessForm.markAllAsTouched();
      return;
    }

    this.isSaving = true;
    this.taskListAirWorthinessApiCall();
  }

  public taskListAirWorthinessApiCall(): void {
    try {
      var obj: any;

      obj = {
        assetTypeId: Number(this.assetTypeId),
        assetId: Number(this.assetId),
        maintenanceTypeId: Number(this.taskListAirWorthinessForm.value.maintenanceTypeId),
        statusListId: Number(this.taskListAirWorthinessForm.value.statusListId),
        thresholdTat: this.taskListAirWorthinessForm.value.thresholdTat
          ? this.taskListAirWorthinessForm.value.thresholdTat
          : null,
        thresholdTac: this.taskListAirWorthinessForm.value.thresholdTac
          ? this.taskListAirWorthinessForm.value.thresholdTac
          : null,
        thresholdDate: this.taskListAirWorthinessForm.value.thresholdDate
          ? format(new Date(this.taskListAirWorthinessForm.value.thresholdDate), 'yyyy-MM-dd')
          : null,
        thresholdDays: this.taskListAirWorthinessForm.value.thresholdDays
          ? this.taskListAirWorthinessForm.value.thresholdDays
          : null,
        repeatIntervalDays: this.taskListAirWorthinessForm.value.repeatIntervalDays
          ? this.taskListAirWorthinessForm.value.repeatIntervalDays
          : null,
        repeatIntervalFh: this.taskListAirWorthinessForm.value.repeatIntervalFh
          ? this.taskListAirWorthinessForm.value.repeatIntervalFh
          : null,
        repeatIntervalFc: this.taskListAirWorthinessForm.value.repeatIntervalFc
          ? this.taskListAirWorthinessForm.value.repeatIntervalFc
          : null,
        occurrenceAlertThreshold: this.taskListAirWorthinessForm.value.occurrenceAlertThreshold
          ? this.taskListAirWorthinessForm.value.occurrenceAlertThreshold
          : null,
        occurrenceAlertRepeatInterval: this.taskListAirWorthinessForm.value.occurrenceAlertRepeatInterval
          ? this.taskListAirWorthinessForm.value.occurrenceAlertRepeatInterval
          : null,
        status: this.taskListAirWorthinessForm.value.status || null,
      };

      // if create for status list
      if (this.data === null) {
        let data = {
          recordObj: obj,
        };
        (this.taskListAirWorthinessSub = this.apiService.addStatusList(data).subscribe(
          (res: any) => {
            if (res !== null) {
              this.apiService.openSnackBar('Data Created Successfully');
              this.taskListAirWorthinessForm.reset();
              this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
              this.modalController.dismiss({
                dismissed: true,
              });
              this.isSaving = false;
            }
          },
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          }
        )),
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          };
      }
      // update for status list
      else {
        obj['id'] = Number(this.data?.assetMaintenanceMappingId);

        let data = {
          recordObj: obj,
        };
        (this.taskListAirWorthinessSub = this.apiService.updateStatusList(data).subscribe(
          (res: any) => {
            if (res !== null) {
              this.apiService.openSnackBar('Data Updated Successfully');
              this.taskListAirWorthinessForm.reset();
              this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
              this.modalController.dismiss({
                dismissed: true,
              });
            }

            this.isSaving = false;
          },
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          }
        )),
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          };
      }
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }

  maintenanceTaskChangebyMaintenanceType(event: any) {
    //all check for repair damage form and validation is null in start until maintenance type is repair damage
    this.selectedMaintenanceTypeList = this.maintenanceTypeList.find((e) => e.value == event.value);
    this.repairDamageFieldsShowHide = false;
    this.formDisableEnableUsingRepairDamageValue = false;
    this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
    // on maintenance task type value change  task id must be null in start until user select from dropdown
    if (event?.value === this.maintenanceTypeList.find((e) => e.name !== this.taskListEnums.REPAIRDAMAGE)?.value) {
      this.taskListAirWorthinessForm.get('statusListId')?.setValue(null);
    }
    if (
      event?.value ===
      this.maintenanceTypeList.find((e) => e.name === this.taskListEnums.AIRWORTHINESSDIRECTIVESTATUS)?.value
    ) {
      this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
      this.repairDamageFieldsShowHide = false;

    }
  }
  searchValue:any
  onInputChange(event: any): void {
     this.searchValue = event?.target?.value?.toLowerCase() || '';

    // this.filteredItems = this.taskIdList.filter((item) => this.getItemLabel(item).toLowerCase().includes(searchValue));
    if (this.filteredItems?.length === 0) {
      this.taskIdLoadingDataLength = true;
    }
  }
  getTaskList(){
    if(this.searchValue){
      this.getData({name:'filter',value:this.searchValue});
    }
  }
  getItemLabel(item: any): string {
    if (!item) return '';

    if (this.selectedMaintenanceTypeList?.name === this.taskListEnums.AIRWORTHINESSDIRECTIVESTATUS) {
      return `FaaAdNum: ${item?.faaAdNum || ''} || EasaAdNum: ${item?.easaAdNum || ''} || OtherAD: ${
        item?.otherAd || ''
      }`;
    }
  }
  displayFn = (id: any): string => {
    if (!id) return '';
    const item = this.taskIdList?.find((x) => x.id == id); // use == in case of string/number mismatch
    return this.getItemLabel(item);
  };
  getSelectedItem(): any {
    const id = Number(this.taskListAirWorthinessForm.get('statusListId')?.value);
    return this.taskIdList.find((item) => item.id === id);
  }

  public ngOnDestroy(): void {
    if (this.awdbSub !== null && this.awdbSub !== undefined) {
      this.awdbSub.unsubscribe();
    }
    if (this.taskListAirWorthinessSub !== null && this.taskListAirWorthinessSub !== undefined) {
      this.taskListAirWorthinessSub.unsubscribe();
    }
  }
  updateDisabledState(): void {
    if (this.editableForm) {
        this.taskListAirWorthinessForm.get('maintenanceTypeId')?.disable({ emitEvent: false });
        this.taskListAirWorthinessForm.get('statusListId')?.disable({ emitEvent: false });
        this.taskListAirWorthinessForm.get('status')?.disable({ emitEvent: false });
        this.taskListAirWorthinessForm.get('occurrenceAlertRepeatInterval')?.disable({ emitEvent: false });
        this.taskListAirWorthinessForm.get('occurrenceAlertThreshold')?.disable({ emitEvent: false });
    } else {
        this.taskListAirWorthinessForm.get('maintenanceTypeId')?.enable({ emitEvent: false });
        this.taskListAirWorthinessForm.get('statusListId')?.enable({ emitEvent: false });
        this.taskListAirWorthinessForm.get('status')?.enable({ emitEvent: false });
        this.taskListAirWorthinessForm.get('occurrenceAlertRepeatInterval')?.enable({ emitEvent: false });
        this.taskListAirWorthinessForm.get('occurrenceAlertThreshold')?.enable({ emitEvent: false });
    }
      const shouldDisable = !!this.editableForm; // Convert to boolean
    this.toggleFormControls(this.taskListAirWorthinessForm, shouldDisable, [
        'type'
    ]);

    // Optional: Trigger Angular's change detection

}
private toggleFormControls(formGroup: FormGroup, disable: boolean, controlNames: string[]): void {
  controlNames.forEach(controlName => {
      const control = formGroup.get(controlName);
      if (control) {
          disable ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });
      }
  });
}

onOptionSelected() {
  this.tooltips.forEach(tooltip => {
    tooltip.close(); // Or tooltip.hide() depending on ejs-tooltip API
  });
}
}
